"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-info.tsx
var Info = function Info(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M9.16699 5.83334H10.8337V7.50001H9.16699V5.83334ZM9.16699 9.16667H10.8337V14.1667H9.16699V9.16667ZM10.0003 1.66667C5.40033 1.66667 1.66699 5.40001 1.66699 10C1.66699 14.6 5.40033 18.3333 10.0003 18.3333C14.6003 18.3333 18.3337 14.6 18.3337 10C18.3337 5.40001 14.6003 1.66667 10.0003 1.66667ZM10.0003 16.6667C6.32533 16.6667 3.33366 13.675 3.33366 10C3.33366 6.32501 6.32533 3.33334 10.0003 3.33334C13.6753 3.33334 16.667 6.32501 16.667 10C16.667 13.675 13.6753 16.6667 10.0003 16.6667Z"
  }));
};

var _default = Info;
exports.default = _default;